import ProductoFactura from "./Factura";

export default ProductoFactura;
